
(function() {
    // Frame changes handler;
// AFTER
let get_frame_select_elements = function() {
    return t('.product-form__option.Size select, .product-form__option.Frame select, #native-white-border-select');
}
    
    // Execute functions when infinity options are loaded
    let on_infinity_options_loaded = function() {
        let frame_select_elements = get_frame_select_elements();
        frame_select_elements.listen('change', (e) => {
            let option_name = e.target.attr('data-select-name');
            frame_change_event_dispatcher(get_current_DOM_frame_data(frame_select_elements, option_name));
        });
    
        let listen_main_fram_first_time_load = function() {
            t('.main-frame .inner-container.frame-container, .room-bg-main-frame .inner-container.frame-container').css('min-height: auto');
            this.removeEventListener('load', listen_main_fram_first_time_load);
        }
    
        tt('img.frame-img ').listen('load', listen_main_fram_first_time_load);
        frame_change_event_dispatcher(get_current_DOM_frame_data(frame_select_elements));	
    };
    
    // Framing functionality
    window.addEventListener('frameChangeEvent', (e) => {
        handle_frame_change_event(e.frame_change_data);
    })
    
    // Handle frame change event
    let handle_frame_change_event = function(frame_change_object) {
        let frame_type, frame_size, frame_border, current_frame_state, current_poster_ratio;
    
        frame_oriantation = "-" + tt('.product-gallery__carousel-item.main-frame').attr('data-frame-oriantation');
    
        current_frame_state = get_current_DOM_frame_data(get_frame_select_elements());
        if (frame_change_object.Frame == false && frame_change_object.Size == false) {
            frame_type = false;
        } else {
            frame_type = frame_change_object.Frame || current_frame_state.Frame;
            frame_type = frame_type.replaceAll(" ", "_");
            frame_size = frame_change_object.Size || current_frame_state.Size;
        }
    
        frame_border = frame_change_object.WhiteBorder;
        new_frame = get_new_frame(frame_type, frame_size);
    
        frame_change_executer(new_frame, frame_border, current_frame_state);
    
        function get_new_frame(frame_type, frame_size) {
    
            if (frame_type == false) { return false };
    
            if (frame_type == "Print_Only") {
                return "hide";
            } else {
                let size_arr, handle_obj;

                size_arr = FrameImgContainer[frame_type + "_frame"];
                handle_obj = size_arr.find((el) => {
                    if ((frame_size + frame_oriantation).includes(el.size_handle)) {
                        return true;
                    }
                });
                return handle_obj;
            }
        }
    
        function frame_change_executer(new_frame, frame_border, current_frame_state) {
            if (new_frame) {
                if (new_frame == 'hide') {
                    let bg_frame_ratio;
    
                    t('.main-frame .frame-container img.frame-img, .room-bg-main-frame img.frame-img').addClass('not-visible');
                    t('.main-frame .frame-container, .room-bg-main-frame .frame-container').addClass('frame-not-visible');
    
                    bg_frame_ratio = FrameImgContainer["Natural_frame"].find((el) => {
                        if ((current_frame_state.Size + frame_oriantation).includes(el.size_handle)) {
                            return true;
                        }
                    });
                    tt('.room-bg-main-frame .room-bg-poster-scaler').css('width:' + bg_frame_ratio.relative_ratio);
                } else {
                    if (tt('.main-frame .frame-container img.frame-img').hasClass("not-visible")) {
                        t('.main-frame .frame-container img.frame-img, .room-bg-main-frame .frame-container img.frame-img').removeClass('not-visible');
                        t('.main-frame .frame-container, .room-bg-main-frame .frame-container').removeClass('frame-not-visible');
                    }
                    tt('.main-frame .frame-container img.frame-img').attr('src', new_frame.size_url);
                    tt('.room-bg-main-frame .frame-container img.frame-img').attr('src', new_frame.size_url);
    
                    t('.main-frame .frame-container .padding-main-art-container, .room-bg-main-frame .frame-container .padding-main-art-container').css('padding:' + new_frame.padding_ratio);
    
                    tt('.room-bg-main-frame .room-bg-poster-scaler').css('width:' + new_frame.relative_ratio);			
                }
            }
    
            if (frame_border) {
                if (frame_border == 'Yes') {
                    t('.main-frame .frame-border-container, .room-bg-main-frame .frame-border-container').addClass('border-on');
                } else if (frame_border == 'No') {
                    t('.main-frame .frame-border-container, .room-bg-main-frame .frame-border-container').removeClass('border-on');
                }
            }
        }
    }
    
    // Listen for changes on frame option select boxes and dispatch new frame change event with option names and values to "window" Object
    let frame_change_event_dispatcher = function(frame_change_object) {
        let frame_change_event = new Event('frameChangeEvent');
        frame_change_event.frame_change_data = frame_change_object;
        window.dispatchEvent(frame_change_event);
    }
    
    let get_current_DOM_frame_data = function(select_elements, option_name) {
        let frame_state_object = {};
        select_elements.each((el) => {
            if (option_name) {
                if (el.attr('data-select-name') == option_name) {
                    frame_state_object[el.attr('data-select-name')] = el.value;
                } else {
                    frame_state_object[el.attr('data-select-name')] = false;
                }
            } else {
                frame_state_object[el.attr('data-select-name')] = el.value;
            }
        });
    
        return frame_state_object;
    }
    
    // Disable zoom in feature for framed images
    t('.product-gallery__thumbnail-list > a').listen('click', (e) => {
        let el, zoom_container;
        el = e.target.closest('a');
        zoom_container = tt('.product-gallery__zoom-notice');
        if (el.hasClass('frame-thumb') && !zoom_container.hasClass('not-visible')) zoom_container.addClass('not-visible');
    
        if (!el.hasClass('frame-thumb') && zoom_container.hasClass('not-visible')) zoom_container.removeClass('not-visible');
    });
    
    // Execute functions when infinity options have been loaded
// AFTER — works with native select, no app needed
if (document.getElementById('native-white-border-select')) {
    on_infinity_options_loaded();
} else if (document.getElementById('native-white-border-select')) {
    on_infinity_options_loaded();
} else if (document.body.attr("data-infinityOptionsLoaded") == "true") {
    on_infinity_options_loaded();
} else {
    window.addEventListener('infinityOptionsLoaded', (e) => {
        on_infinity_options_loaded();
    });
}
    }());